import { $axiosBackend } from '../utils/axios'

export const triggersService = {
  async fetchTriggers (payload) {
    const data = (await $axiosBackend.get(`api/triggers`, { params: payload }))
      .data
    return data
  },
  async sendTrigger (id) {
    const data = (await $axiosBackend.post(`api/triggers/send-pending/${id}`))
      .data
    return data
  }
}
